<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTODESTINO.LBL_DESTINOS' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioDestino" name="nomFormularioDestino"
          *ngIf="!verDetalle">
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTODESTINO.LBL_DESTINO' | translate }}</label>
            <p-multiSelect id="idDestionos" name="nomDestinos" [options]="lisDestinos" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idDestinos"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idDestinos.invalid">
              {{ 'PRODUCTODESTINO.LBL_DESTINO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>{{ 'PRODUCTODESTINO.LBL_SUBDESTINOS' | translate }}</label>
            <p-multiSelect id="idSubdestino" name="nomDestinos" [options]="lisSubdestino" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idSubdestino"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>

          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <p-checkbox binary="true" id="indicadorAnalizamos" name="indicadorAnalizamos"
                        label="* {{ 'PRODUCTOMONTO.LBL_INDICADORANALIZAMOS' | translate}}"
                        (onChange)="validarIndicadores()"
                        formControlName="indicadorAnalizamos"></p-checkbox>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && errorIndicadores" style="display: block; padding: 0px;">
              {{ 'PRODUCTOMONTO.MSG_SELECCIONEINDICADOR' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <p-checkbox binary="true" id="indicadorFlujoDigital" name="indicadorFlujoDigital"
                        label="* {{ 'PRODUCTOMONTO.LBL_INDICADORFLUJODIGITAL' | translate}}"
                        (onChange)="validarIndicadores()"
                        formControlName="indicadorFlujoDigital"></p-checkbox>
          </div>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>


    <div class="grid">
      <div class="col-12 md:col-offset-6 lg:col-offset-6 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dtPDs.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="guardando" #dtPDs
                 [value]="lisProductosDestinos" selectionMode="single" dataKey="idProductoDestino"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.id}}</td>
              <td>{{row.nombreDestinoProducto}}</td>
              <td>{{row.subDestinoCorto}} <span *ngIf="row.verCompleto" (click)="detalleTabla(row)" style="cursor: pointer;">...</span></td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorAnalizamos" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorFlujoDigital" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center" *ngIf="!verDetalle">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-danger btn" icon="fa fa-certificate" data-toggle="tooltip"
                          title="{{'PRODUCTOMONTO.BTN_ACTIVIDADES' | translate}}" pButton
                          *ngIf="row.subDestinoCorto && row.subDestinoCorto.trim()"
                          (click)="verActividades(row)"></button>
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="destinos">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<p-dialog id="dlgCausales"
          [draggable]="false"
          [resizable]="false"
          [closable]="true"

          *ngIf="detalle"
          [(visible)]="detalle"
          [contentStyle]="{'width':'600px', 'overflow-y': 'auto', 'max-height': '350px', 'overflow-x': 'auto'}"
          [header]="tituloDetalle"
          [modal]="true">

  <div class="grid form-group">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="div-form">
        {{textoDetalle}}
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false" #dialo
           *ngIf="mosActividades"
          [(visible)]="mosActividades"
          [contentStyle]="{'width':'800px'}"
          header="{{ 'PRODUCTOMONTO.BTN_ACTIVIDADES'  | translate}}"
          [modal]="true">
  <app-loading *ngIf="carActividades"></app-loading>
  <ng-container *ngIf="!carActividades">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <div class="div-form">
          <label>{{ 'PRODUCTODESTINO.LBL_DESTINO' | translate }}</label>
          <label class="falso-combo-texto">{{regSeleccionado?.nombreDestinoProducto}}</label>
        </div>
      </div>
    </div>
    <form [formGroup]="formActividades" novalidate id="idFormActividades" name="nomFormularioActividades" *ngIf="!verDetalle">
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTODESTINO.LBL_SUBDESTINOS' | translate }}</label>
            <p-dropdown disableTab  id="idSubAct" name="nomDestAci" [options]="lisSubDestinoActividad"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                        filter="filter" (onChange)="cargarActividades($event.value)"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idSubdestino"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="subActividades && fAct.idSubdestino.invalid">
              {{ 'PRODUCTODESTINO.LBL_SUBDESTINOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6" *ngIf="fAct.idSubdestino.value">
          <div class="div-form">
            <label>* {{ 'PRODUCTODESTINO.LBL_ACTIVIDAD' | translate }}</label>
            <p-multiSelect id="idActividadRelacionada" name="actividad" [options]="listActividades" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idActividadRelacionada"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div class="p-message p-messages-error p-corner-all" *ngIf="subActividades && fAct.idActividadRelacionada.invalid">
              {{ 'PRODUCTODESTINO.LBL_ACTIVIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                  type="button" (click)="guardarActividades()"
                  pButton></button>
        </div>
      </div>
    </form>
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dtActividadesSub.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="colActividades" #dtActividadesSub
                 [value]="lisActividadesMostrar"
                 [paginator]="true" [rows]="4"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.subDestinoProducto}}</td>
              <td>{{row.actividadRelacionada}}</td>
              <td class="text-center" *ngIf="!verDetalle">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitarActividad(row)" *ngIf="!verDetalle"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
                pButton (click)="cerrarModal()"></button>
      </div>
    </div>
  </ng-container>
</p-dialog>
